import type { IconSvgObject } from './types';

const KeyframeRemoveIcon: IconSvgObject = [
  ["path", { d: "M15.9999 11.6696L10.7298 5.67215C9.94224 4.77596 8.55792 4.77595 7.77038 5.67214L2.50008 11.6695C1.83331 12.4283 1.83331 13.5717 2.50008 14.3305L7.77038 20.3279C8.55792 21.2241 9.94224 21.224 10.7298 20.3278L15.9999 14.3304C16.6667 13.5717 16.6667 12.4283 15.9999 11.6696Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 4H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default KeyframeRemoveIcon;
